import NextLink from '../next-link';

const NoItems = ({
  icon,
  title,
  description,
  button,
  buttonLink,
  titleClassName = '',
  descriptionClassName = '',
  buttonClassName = '',
  parentClassName = '',
}) => {
  return (
    <div
      className={`flex flex-col items-center justify-center gap-8 max-lg:gap-6 max-md:gap-4 ${parentClassName}`}
    >
      {icon}
      <h2
        className={`text-3xl font-semibold max-lg:text-xl max-md:text-base ${titleClassName}`}
      >
        {title}
      </h2>
      <p
        className={`max-w-96 text-center text-gray-800 max-sm:text-sm ${descriptionClassName}`}
      >
        {description}
      </p>
      <NextLink
        href={buttonLink}
        className={`bg-primary w-60 rounded-md p-2 text-center font-bold text-white uppercase max-md:text-sm max-sm:text-xs ${buttonClassName}`}
      >
        {button}
      </NextLink>
    </div>
  );
};

export default NoItems;
